import { browserHistory } from 'react-router';
import { syncHistoryWithStore } from 'react-router-redux';
import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import createSagaMiddleware from 'redux-saga';
import getSagas from '../sagas';

import reducers from 'reducers';
import { UserPermissionService } from './userPermissions';

export const sagaMiddleware = createSagaMiddleware();

export const store = createStore(
    reducers,
    composeWithDevTools(applyMiddleware(sagaMiddleware)),
);

export const history = syncHistoryWithStore(browserHistory, store);

export function execute(saga, ...args) {
    return sagaMiddleware.run(saga, ...args).done;
}

export const UserPerms = new UserPermissionService(store);

let sagaTask = sagaMiddleware.run(function* () {
    yield getSagas()
});

if (module.hot) {
    module.hot.accept('../reducers', () => {
        const nextRootReducer = require('../reducers');
        store.replaceReducer(nextRootReducer);
    });

    module.hot.accept('../sagas', () => {
        const getNewSagas = require('../sagas');
        sagaTask.cancel();

        sagaTask.done.then(() => {
            sagaTask = sagaMiddleware.run(function* replacedSaga(action) {
                yield getNewSagas()
            })
        })
    });
}


// WEBPACK FOOTER //
// ./app/store/configureStore.js